import { Navigate } from "react-router-dom";
import Authentication from "../containers/Authentication";

export default function routes() {
  return [
    { path: "/", element: <Authentication /> },
    { path: "*", element: <Navigate to="/" replace /> },
  ];
}
